import { render, staticRenderFns } from "./IconAppAdvisor.vue?vue&type=template&id=d5ab090e&"
import script from "./IconAppAdvisor.vue?vue&type=script&lang=js&"
export * from "./IconAppAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports